import moment from "moment";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { GEO_API_KEY } from "@/contains/contants";

export const vapidKey = 'BAWfmR0Y8U3VzZAnKFzeXGTX6rFZh4TxYVDVW5Yow-j3vc128EqdcZ89SjMYyaPOoig9D8ag1VakXrgmE2XTem8'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPrice(price?:number|string,maximumFractionDigits=0){

  price = Number(price);

  if(!price) return "₹0";
  const suffix = "";
  
  try{
    return (price?.toLocaleString('en-IN', { style: 'currency', currency: 'INR',maximumFractionDigits:maximumFractionDigits}) || "₹0" )+ suffix;
  }catch(e){
    return (price?.toLocaleString('en-IN', { style: 'currency', currency: 'INR'}) || "₹0" )+ suffix;
  }
}

export function getDisplayName(name:string) {
  if(name.indexOf('||') != -1) {
    return name.split('||')[1];
  }else{
    return name;
  }
}

export function getAssetUrl(fileName?:string){
  if(!fileName) return "";
  return "/asset/" + fileName?.replaceAll(/\./g, "__") || ""
}

export function getDateString(date?:string|unknown) {
  if (!date) {
    return '-';
  }
  return moment(date).format('DD-MMM-YYYY');
}

export function getFileSize(bytes) {
  if (bytes < 1024) {
    return bytes + " B"; // Bytes if less than 1KB
  } else if (bytes < 1024 * 1024) {
    return (bytes / 1024).toFixed(2) + " KB"; // Kilobytes if less than 1MB
  } else {
    return (bytes / (1024 * 1024)).toFixed(2) + " MB"; // Megabytes otherwise
  }
}

export const aspectRatioMap = {
  "Beyond long vertical": {
    "min": 0,
    "max": 0.43
  },
  "Long Vertical": {
    "min": 0.43,
    "max": 0.56
  },
  "Portrait": {
    "min": 0.56,
    "max": 0.8
  },
  "Square": {
    "min": 0.8,
    "max": 1.25
  },
  "Wide": {
    "min": 1.25,
    "max": 2.33
  },
  "Ultrawide": {
    "min": 2.33,
    "max": 3.6
  },
  "Beyond ultrawide": {
    "min": 3.6,
    "max": Infinity
  }
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')   // Replace non-alphanumeric with hyphen
    .replace(/^-+|-+$/g, '');      // Remove leading/trailing hyphens
}

export type AspectType = keyof typeof aspectRatioMap;

export function getTypeBasedOnAspectRatio(aspectRatio): AspectType|undefined { 
  for (const [key, value] of Object.entries(aspectRatioMap)) {
    if(aspectRatio >= value.min && aspectRatio < value.max){
      return key as AspectType
    }
  }
}

export function shortenPrice(price?:number|string) {
  if(Number(price)>1000){
    return (Number(price)/1000).toFixed(1) + "K";
  }
  return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getDateTimeString(date?:string) {
  if (!date) {
    return '-';
  }
  return moment(date).format('DD-MMM-YYYY HH:mm:ss');
}

export const cityImageMap = {
  "Delhi":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/delhi.webp",
  "Gurugram":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/gurgaon.jpeg!webimage",
  "Pune":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/pune.png!webimage",
  "Chennai":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/chennai.png!webimage",
  "Noida":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/noida.jpeg!webimage",
  "Bengaluru":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/bangalore.png!webimage",
  "Hyderabad":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/hyderabad.png!webimage",
  "Greater Noida":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/greater-noida.jpeg!webimage",
  "Kanpur":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/kanpur.webp!webimage",
  "Mumbai":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/mumbai.webp!webimage",
  "New Delhi":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/delhi.webp!webimage", 
  "Coimbatore":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/coimbatore.webp!webimage", 
  "Nagercoil":"https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com/adboard-booking-web/city-images/nagercoil.webp!webimage", 
}

export const mapAdboardToGtagItem = (adBoard:{
  id:string,
  title:string,
  city:string,
  pricePerDay:number
}, selectedDates:{startDate:string,endDate:string}) => {
  const days = moment(selectedDates.endDate).diff(moment(selectedDates.startDate), 'days')+1;
  return {
    item_id: adBoard.id,
    item_name: adBoard.title,
    item_address: adBoard.city,
    price: adBoard.pricePerDay,
    quantity:days 
  };
}

/**
 * 
 * @param eventName
 * <widget>.<label>.<action>
 */
export function fireEvent(eventName:string, params?:any){
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': eventName,
    ...params
  }); 
}

export function fireMatomoEvent(events){
  // setTimeout(()=>{
  //@ts-ignore
  const _paq = window._paq || [];
  _paq.push(events);
  // })
  
}

export function setPageTitle(title:string){
  if(title == document.title){
    return
  }
  document.title = title;

  // updateMatomo();
}

export function updateGtagTitle(){
  const title = document.title;
  window.dataLayer = window.dataLayer || [];
  // window.dataLayer.push({
  //   'event': 'spa_page_view',
  //   pageTitle: title,
  //   pagePath: window.location.pathname,
  // });
  window.dataLayer.push({
    event: 'page_view',
    page_title: title,
    page_location: window.location.href,
    page_path: location.pathname
  });
}

export function fireEventOnce(eventName:string, params:any){
  if (!sessionStorage.getItem('gtag_'+eventName)) {
    fireEvent(eventName, params);
    sessionStorage.setItem('gtag_'+eventName, 'true');
  }
}

export function titleToUrl(title?:string){
  return title?.replace(/[^a-zA-Z0-9]/g,'-').toLowerCase();
}

export function getLocation(lat, lng) {
  return fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GEO_API_KEY}&enable_address_descriptor=true`)
    .then(res => res.json()).then(res => {
      const { results } = res;
      const addressComponent = results[0]?.address_components;
      const country = addressComponent.find(a => a.types.includes('country'))?.long_name || "";
      const state = addressComponent.find(a => a.types.includes('administrative_area_level_1'))?.long_name || "";
      const city = addressComponent.find(a => a.types.includes('locality'))?.long_name || "";
      const address = results[0].formatted_address || "";
      return {
        address,
        city,
        state,
        country
      }
    })
}